<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">托盘名称：</span>
        <el-input v-model="search.trayName" :size="size" clearable placeholder="请输入托盘名称"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">托盘编号：</span>
        <el-input v-model="search.trayNumber" :size="size" clearable placeholder="请输入托盘编号"></el-input>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
        <!-- <el-button icon="el-icon-upload2" v-if="showButton('export')" @click="exportBigData">导出Excel</el-button> -->
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="trayNumber" label="托盘编号" align="center" width="150"></el-table-column>
        <el-table-column prop="trayName" label="托盘名称" align="center" ></el-table-column>
        <el-table-column prop="isOccupyName" label="是否占用" align="center" ></el-table-column>
        <el-table-column prop="useNumber" label="使用次数" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createUserName" label="创建人" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" width="280">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="printProp(row)">打印</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle? '新增托盘' :'修改托盘'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="45%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="托盘名称：" prop="trayName">
          <el-input v-model="ruleForm.trayName" :size="size" clearable placeholder="请输入托盘名称" ></el-input>
        </el-form-item>
        <el-form-item label="使用次数：" prop="useNumber">
            <el-input-number v-model="ruleForm.useNumber" placeholder="请输入使用次数" :min="0" ></el-input-number>
        </el-form-item>
        <el-form-item label="是否占用：" prop="isOccupy">
            <el-select v-model="ruleForm.isOccupy" placeholder="请选择是否占用">
                <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
    <div v-show="showAbtn">
      <a id="segmentPrint" :href="`printpipe://5,${trayNums}`"><p></p></a>
    </div>
    <!-- 二维码打印弹框 -->
    <el-dialog
      class="prop_dialog"
      title="托盘二维码"
      :close-on-click-modal="false"
      :visible.sync="qrDialogVisible"
      width="400px">
      <div id="qr-print-area" class="qr-print-area">
        <div class="qr-title"></div>
        <div id="qr-code-container" class="qr-code-container"></div>
        <!-- <div class="qr-number">{{ currentTrayNumber }}</div> -->
      </div>
      <div slot="footer">
        <el-button @click="qrDialogVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="printQrCode">打 印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize, downFiles } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        showAbtn: false, // 打印按钮是否显示
        trayNums: null, // 打印的托盘编号
        search:{},//查询条件
        total: 0,
        loading: false,
        dataList: [], //托盘信息列表
        rowIds: null, //选中的行id
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
            trayName: '',
            useNumber: 0,
            isOccupy: '',
        }, // 按钮表单
        rules: {
          trayName: [{
            required: true,
            message: '请输入托盘名称',
            trigger: 'blur'
          }],
          useNumber: [{
            required: true,
            message: '请输入使用次数',
            trigger: 'blur'
          }],
          isOccupy: [{
            required: true,
            message: '请选择是否占用',
            trigger: 'change'
          }],
        },
        optionsType: [
            {
                dictId: 2,
                dictName: '是',
            },
            {
                dictId: 1,
                dictName: '否',
            },
        ], //是否占用状态
        qrDialogVisible: false,
        currentTrayNumber: '',
        qrScriptLoaded: false,
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
    //   that.getAllTypes()
    },
    methods: {
      
      // 打印按钮信息
      printProp(val) {
        this.trayNums = val.trayNumber;
        this.$nextTick(()=>{
            document.getElementById("segmentPrint").click();
        })
        // this.currentTrayNumber = val.trayNumber;
        // this.qrDialogVisible = true;
        // this.$nextTick(() => {
        //   this.loadQrScript().then(() => {
        //     this.generateQrCode(val.trayNumber);
        //   });
        // });
      },
      // 加载二维码脚本
      loadQrScript() {
        return new Promise((resolve, reject) => {
          if (this.qrScriptLoaded) {
            resolve();
            return;
          }
          if (window.QRCode) {
            this.qrScriptLoaded = true;
            resolve();
            return;
          }
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = 'https://cdn.jsdelivr.net/npm/qrcodejs2@0.0.2/qrcode.js';
          script.onload = () => {
            this.qrScriptLoaded = true;
            resolve();
          };
          script.onerror = () => {
            reject(new Error('二维码脚本加载失败'));
            this.$message.error('二维码脚本加载失败');
          };
          document.head.appendChild(script);
        });
      },
      // 生成二维码
      generateQrCode(text) {
        const container = document.getElementById('qr-code-container');
        if (!container) return;
        container.innerHTML = '';
        new window.QRCode(container, {
          text: text,
          width: 220,
          height: 220,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: window.QRCode.CorrectLevel.H
        });
      },
      // 执行打印
      printQrCode() {
        // const printContent = document.getElementById('qr-print-area');
        // if (!printContent) return;
        // const qrHtml = printContent.querySelector('#qr-code-container').innerHTML;
        // // const trayNumber = this.currentTrayNumber;
        // const html = [
        //   '<!DOCTYPE html><html><head><title>托盘二维码打印</title>',
        //   '<style>',
        //   '* { margin: 0; padding: 0; box-sizing: border-box; }',
        //   'body { display: flex; justify-content: center; align-items: center; min-height: 100vh; font-family: "Microsoft YaHei", sans-serif; }',
        //   '.qr-print-area { text-align: center; padding: 20px; }',
        //   '.qr-title { font-size: 20px; font-weight: bold; margin-bottom: 16px; color: #333; }',
        //   '.qr-code-container { display: flex; justify-content: center; margin-bottom: 12px; }',
        //   '.qr-code-container canvas, .qr-code-container img { width: 120px !important; height: 120px !important; }',
        //   '.qr-number { font-size: 18px; font-weight: 500; color: #333; word-break: break-all; }',
        //   '@page { size: auto; margin: 5mm; }',
        //   '@media print { html, body { height: auto; overflow: visible; } .qr-print-area { page-break-inside: avoid; } }',
        //   '</style></head><body>',
        //   '<div class="qr-print-area">',
        //   // '<div class="qr-title">托盘编号</div>',
        //   '<div class="qr-code-container">' + qrHtml + '</div>',
        //   // '<div class="qr-number">' + trayNumber + '</div>',
        //   '</div>',
        //   '<scr' + 'ipt>window.onload=function(){setTimeout(function(){window.print();},300);};</scr' + 'ipt>',
        //   '</body></html>'
        // ].join('');
        // const printWindow = window.open('', '_blank', 'width=500,height=500');
        // printWindow.document.write(html);
        // printWindow.document.close();
      },

    //     //获取占用状态
    //   getAllTypes(){
    //     let params = {
    //         pageNum: 1,
    //         pageSize: 100000000,
    //     }
    //     this.$api.Dictionary.searchDictionary(params).then(res=>{
    //         if(res.statusMsg === 'ok'){
    //             this.optionsType = res.data.list.filter(item=>item.dictType ==='9')
    //         }else{
    //             this.$message.warning(res.statusMsg)
    //         }
    //     })
    //   },
      
    // 转圈圈
    functionLoading() {
        this.loadingView = this.$loading({
            lock: true,
            text: '请稍后...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    //导出Excel
    exportBigData(){
        this.functionLoading();
        let params  = Object.assign({},this.search)
        this.$api.Tray.exportTrayDatas(params).then(res => {
            downFiles(res, '托盘信息', 'xls')
            this.loadingView.close()
        })
        .catch(() => {
          this.loadingView.close();
        })
    },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = true;
        this.$api.Tray.searchTrayList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.rowIds = row.trayId;
        this.$api.Tray.detailsTrayDevice({trayId: row.trayId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Tray.deleteTrayDevice({trayId: row.trayId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.Tray.insertTrayOrUpdate(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm,{
              trayId: this.rowIds
            });
            this.$api.Tray.insertTrayOrUpdate(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';

.qr-print-area {
  text-align: center;
  padding: 20px 10px;
}

.qr-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #333;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  min-height: 220px;

  ::v-deep canvas,
  ::v-deep img {
    width: 220px !important;
    height: 220px !important;
  }
}

.qr-number {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  word-break: break-all;
}
</style>